"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    '0',
    '4px',
    '8px',
    '12px',
    '16px',
    '20px',
    '24px',
    '28px',
    '32px',
    '40px',
    '48px',
    '56px',
    '64px',
    '72px',
    '80px',
    '88px',
    '96px',
    '104px',
    '112px',
    '120px',
    '128px',
    '126px',
    '134px',
];
